import React from 'react'

function Germaine() {

    return (
        <div>
            <p className='post__text'>
                Germaine Cordes dedicates her practice to developing tailored solutions designed to help her clients achieve 
                their goals and financial independence.
            </p>
            <p className='post__text'>
                Born in Redwood City, California, and raised in the Bay Area, Germaine joined the U.S. Army shortly 
                after graduating high school. After seven years of service, she entered the finance world working for a 
                national fleet leasing company in the transportation industry; starting as an account executive and later as a 
                financial analyst. Working extensively with small business owners, she learned the commonalities and financial 
                struggles that many small businesses face.
            </p>
            <p className='post__text'>
                Later, Germaine became a Finance Director at a large commercial truck dealership. There she learned the 
                importance of planning for the “what-ifs” in life. She saw how quickly a person’s fortunes could change after 
                one of her long-time clients suffered a heart attack and six-months later was filing for bankruptcy. 
                That event was the catalyst to her decision to embark on a career as a Financial Planner.
            </p>
            <p className='post__text'>
                Germaine started her Financial Planning career at Lincoln Financial Group in 2002. At Lincoln, 
                she went through an intense training program acquiring in-depth knowledge of portfolio analysis and building, 
                retirement planning, estate planning and business succession planning. Early on, she also entered the complex 
                world of Retirement Income Planning—before the concept had even become mainstream.
            </p>
            <p className='post__text'>
                In 2004, Germaine joined MassMutual Financial Group where she further developed her knowledge of insurance 
                products and cash flow analysis. In 2009, Germaine joined Foothill Securities as an Independent Financial Planner. 
                In December 2016, Foothill Securities became part of Securities America, her current broker-dealer. 
            </p>
            <p className='post__text'>
                Germaine graduated from the University of San Francisco with a Bachelor of Science degree in Applied Economics. 
                She also earned a Paralegal Certificate from Cal State Hayward (ABA approved) with an emphasis in Estate 
                Planning and Corporate Law. Germaine has also earned her designation as a Charted Financial Consultant, ChFC®, 
                which requires the most extensive educational program for any financial services credential.
            </p>
        </div>
    )
}
export default Germaine